import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/styles';
import { CircularProgress, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    center: {
        position: "relative",
        margin: "auto",
        bottom: "70%",
        height: "0px"
    },
    diplaynone: {
        display: "none"
    },
    textaligncenter: {
        textAlign: "center"
    }
}));

const ProcessingBox = props => {
    const { isshow, title, text1, text2 } = props;
    const classes = useStyles();
    return (

        <div className={classes.center + " " + (!isshow ? classes.diplaynone : "")}>
            <div className={classes.textaligncenter}>
                <CircularProgress color="primary" />
                <Typography display="block" color="primary" gutterBottom={true} variant="h4" component="h4">{title}</Typography>
                <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{text1}</Typography>
                <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{text2}</Typography>
            </div>
        </div>

    );
};

ProcessingBox.propTypes = {
    isshow: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    text1: PropTypes.string.isRequired,
    text2: PropTypes.string.isRequired,
};

export default ProcessingBox;
